import * as React from 'react';
import styled from '@emotion/styled';
import ModalContainer from '../../../../../../Modal/ModalContainer';
import useModal from '../../../../../../../hooks/useModal';
import SuggestEditModalBody from './SuggestEditModalBody';
import { PractitionerOrOrganization } from '../../../../../../../interfaces/interfaces';

const StyledSuggestEditLink = styled.a`
  color: #4b286d;

  &:hover {
    color: #092c4c;
  }
`;

interface SuggestEditProps {
  value: PractitionerOrOrganization | undefined;
}

const SuggestEdit = ({ value }: SuggestEditProps) => {
  const modalSuggestEditProps = useModal();

  return (
    <>
      <h3>
        <StyledSuggestEditLink
          onClick={(e) => {
            e.preventDefault();
            modalSuggestEditProps.setIsOpen(true);
          }}
          href=""
        >
          Suggest an Edit
        </StyledSuggestEditLink>
      </h3>
      <ModalContainer {...modalSuggestEditProps}>
        <SuggestEditModalBody value={value} handleClose={modalSuggestEditProps.handleClose} />
      </ModalContainer>
    </>
  );
};

export default SuggestEdit;
